export const zIndex = {
    header: '1000'
}
